import { render, staticRenderFns } from "./cbuydet.vue?vue&type=template&id=362e8324&scoped=true&"
import script from "./cbuydet.vue?vue&type=script&lang=js&"
export * from "./cbuydet.vue?vue&type=script&lang=js&"
import style0 from "./cbuydet.vue?vue&type=style&index=0&id=362e8324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362e8324",
  null
  
)

export default component.exports